import { publish } from 'ert-framebus';
import { PubSubMessages } from '../../../config';
import { UserService, UpdateUserProfileData } from 'navigator-header';

export class UserServiceImpl implements UserService {

    updateUserProfile(data: UpdateUserProfileData): void {
        publish(PubSubMessages.updateUserProfile, data);
    }

    clearCachedStudies(): void {
        publish(PubSubMessages.clearCachedStudies);
    }

    logout(informBackend: boolean = true): void {
        publish(PubSubMessages.logout, informBackend);
    }
}
